<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">PTP Metadata Maps</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="margin-bottom: 16px; display: flex; gap: 8px; align-items: center">
            <button nz-button nzType="primary" (click)="addMap()">Add Metadata Map</button>
        </div>
        <nz-table #mapTable [nzData]="maps" nzTableLayout="fixed" nzBordered="true" [nzLoading]="loading">
            <thead>
                <tr>
                    <th>PO Field</th>
                    <th>Metadata Field</th>
                    <th nzWidth="160px"></th>
                </tr>
            </thead>
            <tbody>
                @for (map of mapTable.data; track map.PTPMetaDataMapID) {
                    <tr>
                        <td>{{ map.ColumnName }}</td>
                        <td>{{ map.MetaDataDefinitionName }}</td>
                        <td style="text-align: center">
                            <button nz-button class="btn btn-default" (click)="editMap(map.PTPMetaDataMapID)">
                                Edit
                            </button>
                            <button
                                nz-button
                                nzDanger
                                style="margin-left: 8px"
                                nz-popconfirm
                                nzPopconfirmTitle="Are you sure you want to delete this metadata map?"
                                (nzOnConfirm)="deleteMap(map.PTPMetaDataMapID)">
                                Delete
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
    </div>
</div>
